document.addEventListener('DOMContentLoaded', function () {
    // Replace this URL with your uploaded PDF URL
    var pdfUrl = 'https://www.capandgowndirect.com/pages/graduation-templates';
    new QRCode(document.getElementById('qrcode'), {
      text: pdfUrl,
      width: 150,
      height: 150,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H,
    });
  });